import React from 'react';
import NewVersionNotice from './components/NewVersionNotice';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import * as Root from './routes/Root';
import * as Index from './routes/Index';
import * as Debug from './routes/Debug';
import * as Profile from './routes/Profile';
import * as ApplicationGDPRConsent from './routes/ApplicationGDPRConsent';
import * as ApplicationUpdate from './routes/ApplicationUpdate';
import * as ApplicationUpdateIdentity from './routes/ApplicationUpdateIdentity';
import * as ApplicationUpdateNames from './routes/ApplicationUpdateNames';
import * as ApplicationUpdateBirth from './routes/ApplicationUpdateBirth';
import * as ApplicationUpdateAddresses from './routes/ApplicationUpdateAddresses';
import * as ApplicationUpdateDocuments from './routes/ApplicationUpdateDocuments';
import * as ApplicationSubmit from './routes/ApplicationSubmit';
import * as ApplicationAutomatedVerification from './routes/ApplicationAutomatedVerification';
import * as ApplicationMeeting from './routes/ApplicationMeeting';
import * as ApplicationMeetingGroup1 from './routes/ApplicationMeetingGroup1';
import * as ApplicationMeetingGroup2 from './routes/ApplicationMeetingGroup2';
import * as ApplicationMeetingSummary from './routes/ApplicationMeetingSummary';
import * as ApplicationPayment from './routes/ApplicationPayment';
import * as ApplicationPaymentStripe from './routes/ApplicationPaymentStripe';
import * as ApplicationPaymentStripeComplete from './routes/ApplicationPaymentStripeComplete';
import ErrorPage from './components/ErrorPage';
import { queryClient } from './bootstrapping/InitReactQuery';
import './App.css';

const router = () => createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={<Root.Element />}
    >
      <Route errorElement={<ErrorPage />}>
        <Route
          index
          loader={Index.loader(queryClient)}
          element={<Index.Element />}
        />
        <Route
          path="debug"
          element={<Debug.Element />}
        />
        <Route
          path="profile"
          element={<Profile.Element />}
        />
        <Route
          path="applications/:application_id/gdpr"
          loader={ApplicationUpdate.loader(queryClient)}
          element={<ApplicationGDPRConsent.Element />}
        />
        <Route
          path="applications/:application_id/identity"
          loader={ApplicationUpdate.loader(queryClient)}
          element={<ApplicationUpdateIdentity.Element />}
          action={ApplicationUpdate.action}
        />
        <Route
          path="applications/:application_id/names"
          loader={ApplicationUpdate.loader(queryClient)}
          element={<ApplicationUpdateNames.Element />}
          action={ApplicationUpdate.action}
        />
        <Route
          path="applications/:application_id/birth"
          loader={ApplicationUpdate.loader(queryClient)}
          element={<ApplicationUpdateBirth.Element />}
          action={ApplicationUpdate.action}
        />
        <Route
          path="applications/:application_id/addresses"
          loader={ApplicationUpdate.loader(queryClient)}
          element={<ApplicationUpdateAddresses.Element />}
          action={ApplicationUpdate.action}
        />
        <Route
          path="applications/:application_id/documents"
          loader={ApplicationUpdate.loader(queryClient)}
          element={<ApplicationUpdateDocuments.Element />}
          action={ApplicationUpdate.action}
        />
        <Route
          path="applications/:application_id/submit"
          loader={ApplicationSubmit.loader(queryClient)}
          element={<ApplicationSubmit.Element />}
          action={ApplicationSubmit.action}
        />
        <Route
          path="applications/:application_id/automated-verification"
          element={<ApplicationAutomatedVerification.Element />}
        />
        <Route
          path="applications/:application_id/meeting"
          element={<ApplicationMeeting.Element />}
        />
        <Route
          path="applications/:application_id/meeting/group1"
          element={<ApplicationMeetingGroup1.Element />}
        />
        <Route
          path="applications/:application_id/meeting/group2"
          element={<ApplicationMeetingGroup2.Element />}
        />
        <Route
          path="applications/:application_id/meeting/summary"
          element={<ApplicationMeetingSummary.Element />}
        />
        <Route
          path="applications/:application_id/payment"
          element={<ApplicationPayment.Element />}
        />
        <Route
          path="applications/:application_id/payment/stripe"
          element={<ApplicationPaymentStripe.Element />}
        />
        <Route
          path="applications/:application_id/payment/stripe/complete"
          element={<ApplicationPaymentStripeComplete.Element />}
        />
      </Route>
    </Route>
  )
)

const App: React.FC = () => {
  console.log("[App] Loaded!")
  return <>
    <RouterProvider router={router()} />
    <NewVersionNotice />
  </>
}

export default App;
